<template>
  <div class="dashboard">
    <v-container>
      <h1 class="text-center">Hello {{ userinfo.name }} !</h1>
      <v-row class="text-center">
        <v-col></v-col>
        <v-col cols="2">
          <p>REFRESH ALL</p>
          <v-btn icon @click="getAllData">
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col>
          <v-card elevation="20">
            <v-card-title>PRODUCTS</v-card-title>
            <div>
              <p
                class="text-center"
              >We have {{ PRODUCTS != undefined ? PRODUCTS.length : '0'}} PRODUCTS</p>
            </div>
            <v-card-actions>
              <v-btn block dark @click="nav('/PRODUCTS')" color="primary1">VIEW PRODUCTS</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="20">
            <v-card-title>VENDORS</v-card-title>
            <div>
              <p
                class="text-center"
              >We have {{ VENDORS != undefined ? VENDORS.length : '0'}} VENDORS</p>
            </div>
            <v-card-actions>
              <v-btn block dark @click="nav('/VENDORS')" color="primary1">VIEW VENDORS</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="20">
            <v-card-title>CATEGORY</v-card-title>
            <div>
              <p
                class="text-center"
              >We have {{ CATEGORY != undefined ? CATEGORY.length : '0'}} CATEGORY</p>
            </div>
            <v-card-actions>
              <v-btn block dark @click="nav('/CATEGORY')" color="primary1">VIEW CATEGORY</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    userinfo: {},
  }),
  activated() {
    this.userinfo = this.$session.get("userinfo");
    this.getAllData();
  },
  methods: {
    ...mapActions(["GET_ALL"]),
    nav(val) {
      this.$router.replace(val);
    },
    getAllData() {
      this.$store.commit("SET_LOADING", true);
      this.GET_ALL().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
  },
  computed: {
    ...mapGetters([
      "PRODUCTS",
      "CATEGORY",
      "VENDORS",
      "SHOPDATA",
      "STOCKROOM",
      "BILLS",
    ]),
  },
  watch: {},
  components: {},
};
</script>
<style scoped></style>
